interface PillProps {
  number: string;
  title: string;
  description: string;
}

/**
 * Pill component for numbered steps in a process
 * Used to display pipeline stages or workflow steps
 *
 * @example
 * <Pill
 *   number="1"
 *   title="Upload"
 *   description="CSV upload with instant validation"
 * />
 */
export function Pill({
  number,
  title,
  description
}: PillProps) {
  return (
    <div className="flex flex-col items-center text-center">
      <div className="relative mb-3">
        <div className="w-12 h-10 rounded-full bg-[#2F7BFF]/10 flex items-center justify-center">
          <span className="text-lg font-semibold text-[#2F7BFF]">{number}</span>
        </div>
      </div>
      <h4 className="font-semibold text-[#0E1325] mb-1 text-sm">{title}</h4>
      <p className="text-xs text-[#5F6B7A]">{description}</p>
    </div>
  );
}
